import { useEffect } from "react";
import { useCookieConsent } from "../contexts/CookieConsentContext";

const CLARITY_PROJECT_ID = "wmfj4htk4c";

const ClarityAnalytics = () => {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    // Only load Clarity if user has given consent
    if (!hasConsent || typeof window === "undefined" || !CLARITY_PROJECT_ID) {
      return;
    }

    if (window.clarity) {
      return;
    }

    ((c, l, a, r, i, t, y) => {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = `https://www.clarity.ms/tag/${i}`;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
  }, [hasConsent]);

  return null;
};

export default ClarityAnalytics;
